import Vue from 'vue'

export default {
    handleMildAxiosError(exception) {
        const vm = new Vue()
        vm.$bvToast.toast('Es ist ein Fehler aufgetreten. ' + exception.message, {
            title: 'Fehler!',
            autoHideDelay: 1000,
            appendToast: true,
            variant: 'danger'
        })
    },
    handleSuccessMessage(message, title = "Erfolgreich") {
        const vm = new Vue()
        const h = vm.$createElement
        const vNodesTitle = h(
            'div',
            [
                h('b-icon-info-circle', {props: {variant: 'success'}}),
                h('strong', {class: 'ml-2'}, title),
            ]
        )
        vm.$bvToast.toast(message, {
            title: [vNodesTitle],
            autoHideDelay: 1000,
            appendToast: true,
        })
    },
    handleWarningMessage(message, title = "Achtung") {
        const vm = new Vue()
        const h = vm.$createElement
        const vNodesTitle = h(
            'div',
            [
                h('b-icon-exclamation-triangle', {props: {variant: 'warning'}}),
                h('strong', {class: 'ml-2'}, title),
            ]
        )
        vm.$bvToast.toast(message, {
            title: [vNodesTitle],
            autoHideDelay: 4000,
        })
    }
}
